<ng-container *ngIf="initialized">
  <form class="form" (ngSubmit)="onSave()" #myForm="ngForm" novalidate>
    <div id="composeEmail" class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Email</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12 d-flex bd-highlight">
            <div class="p-2 bd-highlight compose-label">To</div>
            <div class="flex-grow-1 bd-highlight">
              <kendo-multiselect [(ngModel)]="model.to" name="to" [popupSettings]="{ popupClass: 'email-search-popup' }" [valueNormalizer]="valueNormalizer" [filterable]="false" (filterChange)="handleFilter($event)" [data]="userData | async" [loading]="userLoading" [valuePrimitive]="false" textField="fullName" valueField="id" [placeholder]="'Enter or choose existing'" [allowCustom]="true">
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                  <div class="d-flex">
                    <img style="width: 30px; height: 30px" class="rounded-circle" [fallback]="'fetch-avatar?userId=' + dataItem.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ dataItem.id }}-avatar.png"  />
                    <div class="ml-1 flex-grow" style="padding-top: 0.2rem">
                      <div class="d-block">{{ dataItem.lastName }} {{ dataItem.firstName }} ({{ dataItem.email }})</div>
                    </div>
                  </div>
                </ng-template>
              </kendo-multiselect>
            </div>
          </div>
          <div *ngIf="cc" class="col-md-12 d-flex bd-highlight">
            <div class="p-2 bd-highlight compose-label">Cc</div>
            <div class="flex-grow-1 bd-highlight">
              <kendo-multiselect [(ngModel)]="model.cc" name="cc" [popupSettings]="{ popupClass: 'email-search-popup' }" [valueNormalizer]="valueNormalizer" [filterable]="false" (filterChange)="handleFilter($event)" [data]="userData | async" [loading]="userLoading" [valuePrimitive]="false" textField="fullName" valueField="id" [placeholder]="'Enter or choose existing'" [allowCustom]="true">
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                  <div class="d-flex">
                    <img style="width: 30px; height: 30px" class="rounded-circle" [fallback]="'fetch-avatar?userId=' + dataItem.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ dataItem.id }}-avatar.png" />
                    <div class="ml-1 flex-grow" style="padding-top: 0.2rem">
                      <div class="d-block">{{ dataItem.lastName }} {{ dataItem.firstName }} ({{ dataItem.email }})</div>
                    </div>
                  </div>
                </ng-template>
              </kendo-multiselect>
            </div>
          </div>
          <div *ngIf="bcc" class="col-md-12 d-flex bd-highlight">
            <div class="p-2 bd-highlight compose-label">Bcc</div>
            <div class="flex-grow-1 bd-highlight">
              <kendo-multiselect [(ngModel)]="model.bcc" name="bcc" [popupSettings]="{ popupClass: 'email-search-popup' }" [valueNormalizer]="valueNormalizer" [filterable]="false" (filterChange)="handleFilter($event)" [data]="userData | async" [loading]="userLoading" [valuePrimitive]="false" textField="fullName" valueField="id" [placeholder]="'Enter or choose existing'" [allowCustom]="true">
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                  <div class="d-flex">
                    <img style="width: 30px; height: 30px" class="rounded-circle" [fallback]="'fetch-avatar?userId=' + dataItem.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ dataItem.id }}-avatar.png" />
                    <div class="ml-1 flex-grow" style="padding-top: 0.2rem">
                      <div class="d-block">{{ dataItem.lastName }} {{ dataItem.firstName }} ({{ dataItem.email }})</div>
                    </div>
                  </div>
                </ng-template>
              </kendo-multiselect>
            </div>
          </div>
          <div class="col-md-12 d-flex bd-highlight">
            <div class="p-2 bd-highlight compose-label">From</div>
            <div class="p-2 flex-grow-1 from-address">paper{{ paperSubmission.id }}@paper-mail.{{ settings.brand.brandName.toLowerCase() }}.com</div>
            <div *ngIf="!bcc || !cc" class="p-2 bd-highlight compose-label">
              <a *ngIf="!cc" href="javascript:void(0)" (click)="cc = true" class="text-admin-primary mr-2">Cc</a>
              <a *ngIf="!bcc" href="javascript:void(0)" (click)="bcc = true" class="text-admin-primary">Bcc</a>
            </div>
          </div>
          <div class="col-md-12">
            <hr class="m-0" />
          </div>
          <div class="col-md-12 d-flex bd-highlight">
            <div class="p-2 bd-highlight subject-label compose-label">Subject</div>
            <div class="p-2 flex-grow-1 bd-highlight"><input [(ngModel)]="model.subject" name="subject" required class="subject" /></div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <ckeditor [editor]="Editor" [config]="htmlEditorConfig" [(ngModel)]="model.body" name="body" (ready)="onReady($event)" style="width: 100%"></ckeditor>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-sm btn-secondary mr-2" [disabled]="!model.to || model.to.length == 0 || !model.body || model.body.length == 0" type="submit">
              <i class="fas fa-paper-plane mr-1"></i>
              <span>Send</span>
            </button>
            <button class="btn btn-sm btn-outline-dark" (click)="onCancel()" type="button">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
